var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultTimeComboBoxProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import TimeSelect from './TimeSelect';
import { getSelectOption, DATEOPERATETYPE, getNumTwoBit } from './utils';
import { scrollTo } from '../../Utils/browser';
import { formatTime } from '@feb-team/data-logic';
var TimeComboBox = /** @class */ (function (_super) {
    __extends(TimeComboBox, _super);
    function TimeComboBox(props) {
        var _this = _super.call(this, props) || this;
        _this.handerMouseDown = function (e) {
            if (_this.state.mouseOver) {
                e.preventDefault();
            }
        };
        _this.handleMouseEnter = function () {
            _this.setState({
                mouseOver: true,
            });
        };
        _this.handleMouseLeave = function () {
            _this.setState({
                mouseOver: false,
            });
        };
        /** 选择时间 */
        _this.onSelectTime = function (e, type, time, idx, refs) {
            var nextInpValDate = _this.props.value ? _this.props.value.split(':') : ['00', '00', '00'];
            switch (type) {
                case 'h':
                    nextInpValDate[0] = getNumTwoBit(time.value).toString();
                    break;
                case 'm':
                    nextInpValDate[1] = getNumTwoBit(time.value).toString();
                    break;
                default:
                    nextInpValDate[2] = getNumTwoBit(time.value).toString();
            }
            scrollTo(0, idx * 28, { duration: 500 }, function () { }, refs ? refs : window);
            _this.setState({
                inpValDate: nextInpValDate.join(':'),
            });
            _this.props.onChange(e, nextInpValDate.join(':'));
        };
        /** 此刻 */
        _this.setTimeNow = function (e) {
            _this.props.onChange(e, formatTime(new Date()), 'now');
        };
        /** 确定 */
        _this.confirm = function (e) {
            _this.props.onChange(e, _this.state.inpValDate, 'confirm');
        };
        _this.state = {
            mouseOver: false,
            inpValDate: _this.props.value ? _this.props.value : '00:00:00',
        };
        return _this;
    }
    TimeComboBox.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handerMouseDown, false);
    };
    TimeComboBox.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handerMouseDown);
    };
    /** 初始化时间 */
    TimeComboBox.prototype.initTimeDate = function () {
        return '00:00:00';
    };
    /** 设置 */
    TimeComboBox.prototype.timeSlots = function () {
        if (!this.props.value)
            return ['00', '00', '00'];
        return this.props.value.split(':');
    };
    TimeComboBox.prototype.renderContext = function () {
        var _a = this.props, format = _a.format, hourStep = _a.hourStep, secondStep = _a.secondStep, minuteStep = _a.minuteStep, panel = _a.panel, onChange = _a.onChange, showNow = _a.showNow, nowText = _a.nowText, confirmText = _a.confirmText, value = _a.value, open = _a.open, rest = __rest(_a, ["format", "hourStep", "secondStep", "minuteStep", "panel", "onChange", "showNow", "nowText", "confirmText", "value", "open"]);
        var contextTimeCls = [
            'w-full',
            'flex',
            panel == 'default' ? 'h-px-262' : 'h-full',
            'bg-white',
        ];
        var formatStr = format.toLocaleLowerCase();
        var style = panel == 'default' ? { boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.15)' } : {};
        return (React.createElement(DivTag, __assign({ atomics: contextTimeCls, style: style }, rest, { autoPrefixedClassName: "time-picker-combobox" }),
            formatStr.indexOf('h') > -1 ? (React.createElement(TimeSelect, { type: "h", options: getSelectOption({ type: DATEOPERATETYPE.HOUR, interval: hourStep }), value: Number(this.timeSlots()[0]), onSelectTime: this.onSelectTime, panel: panel })) : null,
            formatStr.indexOf('m') > -1 ? (React.createElement(TimeSelect, { type: "m", options: getSelectOption({ type: DATEOPERATETYPE.MINUTE, interval: minuteStep }), value: Number(this.timeSlots()[1]), onSelectTime: this.onSelectTime, panel: panel })) : null,
            formatStr.indexOf('s') > -1 ? (React.createElement(TimeSelect, { type: "s", options: getSelectOption({ type: DATEOPERATETYPE.SECOND, interval: secondStep }), value: Number(this.timeSlots()[2]), onSelectTime: this.onSelectTime, panel: panel })) : null));
    };
    TimeComboBox.prototype.renderFooter = function () {
        var _this = this;
        var _a = this.props, showNow = _a.showNow, nowText = _a.nowText, confirmText = _a.confirmText;
        var contextFooterCls = [
            'flex',
            'justify-between',
            'items-center',
            'h-px-40',
            'border-t',
            'py-px-4',
            'px-px-12',
            'text-brand-600',
            'bg-white',
            'rounded-b-default',
        ];
        var footerNowCls = ['cursor-pointer'];
        var footerConfirmCls = [
            'w-px-64',
            'h-px-24',
            'bg-brand-600',
            'cursor-pointer',
            'text-white',
            'rounded-sm',
            'text-center',
            'text-xs',
            'leading-6',
        ];
        var style = this.props.panel == 'default' ? { boxShadow: '0px 4px 8px 0px rgba(0,0,0,0.15)' } : {};
        return (React.createElement(DivTag, { atomics: contextFooterCls, style: style },
            showNow && (React.createElement(DivTag, { atomics: footerNowCls, onClick: function (e) { return _this.setTimeNow(e); } }, nowText)),
            React.createElement(DivTag, { atomics: footerConfirmCls, onClick: function (e) { return _this.confirm(e); } }, confirmText)));
    };
    TimeComboBox.prototype.render = function () {
        var contextCls = ['z-50', 'h-full'];
        var panel = this.props.panel;
        if (panel == 'default') {
            contextCls = contextCls.concat([
                'absolute',
                'mt-px-30',
                'pt-px-4',
                'top-0',
                'left-0',
                'w-px-220',
            ]);
        }
        return (React.createElement(DivTag, { atomics: contextCls, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
            this.renderContext(),
            panel == 'default' && this.renderFooter()));
    };
    TimeComboBox.defaultProps = defaultTimeComboBoxProps;
    return TimeComboBox;
}(React.Component));
export default TimeComboBox;
